import { Token } from 'src/common/types/models/Tokens'

export function getTokenAddresses(
  tokens: (Pick<Token, 'contractAddress'> | undefined)[] = []
): string[] {
  return tokens.flatMap(token =>
    token?.contractAddress ? [token.contractAddress] : []
  ) // Only map to contractAddress if defined
}
